import React, { Component } from 'react';
import { connect } from 'react-redux';
import './frontpageupdates.css';
import Projectblock from '../projectblock/projectblock';
import Newsblockfrontpage from '../newsblockfrontpage/newsblockfrontpage';
import { newsCategories, projectCategories } from '../../utilities';
import Frontpageblockonswerk from '../frontpageblockonswerk/frontpageblockonswerk';
import RandomEmployee from '../randomEmployee/randomEmployee';
import { featuredImageWithFallback } from '../../utilities';

class Frontpageupdates extends Component {

    render() {
        let newsImage = featuredImageWithFallback(this.props.newsitem, 'medium_large');

        return (
            <div className="frontpageupdates">

                <Frontpageblockonswerk/>

                {
                    this.props.projects.slice(0,3).map((project, index) => {
                        const projectCategoriesText = projectCategories(project);
                        let projectImage = featuredImageWithFallback(project, 'medium_large');
                        return ( <Projectblock key={project.id} id={project.id} slug={project.slug} title={project.title.rendered} projectCategories={projectCategoriesText} image={projectImage}/> )
                    })
                }

                <Newsblockfrontpage id={this.props.newsitem.id} slug={this.props.newsitem.slug} title={this.props.newsitem.title.rendered} category={newsCategories(this.props.newsitem)} link={this.props.newsitem.link} image={newsImage}/>
                <RandomEmployee/>

            </div>
        );
    }
}

const mapStateToProps = (store) => {
    let projects = [];
    let newsitem = {
        id: "",
        link : "",
        title: {
            rendered: ""
        },
        excerpt: {
            rendered: ""
        }
    };

    if (store.projects && store.projects.projects) {
        projects = store.projects.projects;
    }

    if (store.news && store.news.news) {
        newsitem = store.news.news[0];
    }

    return {
        projects: projects,
        newsitem : newsitem
    }
}

export default connect(mapStateToProps)(Frontpageupdates);



// WEBPACK FOOTER //
// ./src/components/frontpageupdates/frontpageupdates.js